export default __webpack_public_path__ + "static/media/arrow-down.ac054c6a.svg";